<script lang="ts">
  import ActionBarCard from "@shared/svelte/Components/ActionBarCard.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import DesktopDistributors from "./DesktopDistributors.svelte";
  import MobileDistributors from "./MobileDistributors.svelte";
  import { compareOrderCounts } from "@retailer/services/retailer_distributors_comparator_service";
  import { cloneDeep } from "lodash";
  import { EventTracking } from "@shared/services/event_tracking/events";

  import type { DistributorOrderCounts } from "@shared/types/Distributor";
  import type { Distributor } from "@shared/types/Distributor";

  export let distributors: Distributor[] = [];

  const { trackClick } = EventTracking;

  let innerWidth = window.innerWidth;
  let distributorOrderCounts: DistributorOrderCounts = {};

  const fetchDistributorOrderCounts = async () => {
    try {
      distributorOrderCounts = await HttpPromise({
        method: "GET",
        url: "api/retailer/retailers/distributor_order_counts",
      });
    } catch (e) {
      console.log(e);
    }
  };
  fetchDistributorOrderCounts();

  $: isLoading = Object.keys(distributorOrderCounts).length === 0;

  $: recentlyOrdered = cloneDeep(distributors)
    .sort((a, b) => compareOrderCounts(a, b, distributorOrderCounts))
    .slice(0, 3);
</script>

<svelte:window bind:innerWidth />

<ActionBarCard
  titleText="My distributor catalogs"
  icon="Truck"
  actionText="See all"
  actionLink="/distributors"
  on:actionClick={() => trackClick("action_bar_distributor_catalog_see_all_link")}
>
  <div slot="body">
    {#if innerWidth >= 1200}
      <div class="fizz-inset-square-8">
        <DesktopDistributors {isLoading} distributors={recentlyOrdered} />
      </div>
    {:else}
      <MobileDistributors {isLoading} distributors={recentlyOrdered} />
    {/if}
  </div>
</ActionBarCard>
